import { Schema } from 'effect';

export const UserSchema = Schema.transform(
  Schema.Struct({
    id: Schema.optional(Schema.NullOr(Schema.Number)),
    name: Schema.String,
    email: Schema.String,
    max_vehicles_per_rpic: Schema.optional(Schema.NullOr(Schema.Int))
  }),
  Schema.Struct({
    id: Schema.optional(Schema.NullOr(Schema.Number)),
    name: Schema.String,
    email: Schema.String,
    maxVehiclesPerRpic: Schema.optional(Schema.NullOr(Schema.Int))
  }),
  {
    strict: true,
    decode: (api) => ({
      id: api.id,
      name: api.name,
      email: api.email,
      maxVehiclesPerRpic: api.max_vehicles_per_rpic
    }),
    encode: (client) => ({
      id: client.id,
      name: client.name,
      email: client.email,
      max_vehicles_per_rpic: client.maxVehiclesPerRpic
    })
  }
);
export type User = Schema.Schema.Type<typeof UserSchema>;

export const IsLoggedInResponseSchema = Schema.transform(
  Schema.Struct({
    is_logged_in: Schema.Boolean
  }),
  Schema.Struct({
    isLoggedIn: Schema.Boolean
  }),
  {
    decode: (api) => ({
      isLoggedIn: api.is_logged_in
    }),
    encode: (client) => ({
      is_logged_in: client.isLoggedIn
    })
  }
);
export type IsLoggedInResponse = Schema.Schema.Type<typeof IsLoggedInResponseSchema>;

export const SignInWithOktaRequestSchema = Schema.transform(
  Schema.Struct({
    code: Schema.String,
    redirect_uri: Schema.String
  }),
  Schema.Struct({
    code: Schema.String,
    redirectUri: Schema.String
  }),
  {
    strict: true,
    decode: (api) => ({
      code: api.code,
      redirectUri: api.redirect_uri
    }),
    encode: (client) => ({
      code: client.code,
      redirect_uri: client.redirectUri
    })
  }
);
export type SignInWithOktaRequest = Schema.Schema.Type<typeof SignInWithOktaRequestSchema>;
